export default __webpack_public_path__ + "static/media/Facebook.2db86d45.svg";